module.exports = __webpack_public_path__ + "static/L2_ux_1_3_do-89edb020abdf168b01e4360a867d65be.png";